export const MyInfo = {
    NAME: "Nagaraju Kasarla",
    EMAIL: "nagarajukasarla79@gmail.com",
    ADDRESS: "Hyderabad, Telangana, India",
    LINKEDIN: "https://www.linkedin.com/in/nagaraju-kasarla-645697232",
    GITHUB: "https://github.com/Nagarajukasarla",
    TELEGRAM: "https://t.me/nagarajukasarla",
}

export const SERVICES = [
    {
        title: "Web Development",
        description:
            "I craft dynamic, responsive, and visually engaging web applications using modern frontend frameworks, with a focus on performance, accessibility, and delivering clean user experiences by turning designs into pixel-perfect interfaces.",
        tags: ["React", "Next.js", "TypeScript"],
    },
    {
        title: "Backend Development",
        description:
            "I build secure and scalable backend systems focused on clean architecture, well-structured and robust authentication. My code is maintainable, performance-driven, and built to ensure stability and reliability across modern applications.",
        tags: ["Node.js", "Java", "Spring Boot"],
    },
    {
        title: "Database Design",
        description:
            "I design and optimize reliable database systems with a focus on clean schema architecture, secure data flow, and high performance. My goal is to ensure data is structured, accessible, and scalable to meet evolving application demands.",
        tags: ["MongoDB", "PostgreSQL", "MySQL"],
    },
    {
        title: "API Development",
        description:
            "I create well-structured, efficient, and secure RESTful APIs that serve as the backbone of seamless communication between frontend interfaces and backend systems.",
        tags: ["REST"],
    },
    {
        title: "Mobile Development",
        description:
            "I build cross-platform mobile applications with a focus on smooth performance, intuitive UI, and native-like experiences,designed to run seamlessly across both Android and iOS devices.",
        tags: ["React Native", "Android"],
    },
    {
        title: "Deployment",
        description:
            "I streamline deployment processes with version control, CI/CD pipelines, and cloud platforms to ensure smooth, reliable, and scalable application delivery.",
        tags: ["Github Actions", "CI/CD", "Google Cloud"],
    },
];

export const PROJECTS = [
    {
        image: {
            small: "https://raw.githubusercontent.com/Nagarajukasarla/weather-dashboard/master/src/assets/screenshots/Mapview.png",
            medium: "https://raw.githubusercontent.com/Nagarajukasarla/weather-dashboard/master/src/assets/screenshots/Mapview.png",
            large: "https://raw.githubusercontent.com/Nagarajukasarla/weather-dashboard/master/src/assets/screenshots/Mapview.png",
            default: "https://raw.githubusercontent.com/Nagarajukasarla/weather-dashboard/master/src/assets/screenshots/Mapview.png",
        },
        title: "Weather Dashboard",
        description: "The Weather Dashboard is an interactive web application that makes exploring weather data intuitive and visual. With map-based controls and insightful charts, you can analyze weather conditions tailored to your region of interest.",
        tags: ["React", "TypeScript", "Recharts & Nivo", "Tailwind CSS", "OpenWeatherMap API"],
        link: "https://weather-dashboard.nagarajukasarla.live",
        year: 2025,
    },
    {
        image: {
            small: "https://raw.githubusercontent.com/Nagarajukasarla/UrbanAccess-admin/master/client/src/assets/img/screenshots/home.jpeg",
            medium: "https://raw.githubusercontent.com/Nagarajukasarla/UrbanAccess-admin/master/client/src/assets/img/screenshots/home.jpeg",
            large: "https://raw.githubusercontent.com/Nagarajukasarla/UrbanAccess-admin/master/client/src/assets/img/screenshots/home.jpeg",
            default:
                "https://raw.githubusercontent.com/Nagarajukasarla/UrbanAccess-admin/master/client/src/assets/img/screenshots/home.jpeg",
        },
        title: "UrbanAccess Admin Portal",
        description:
            "UrbanAccess Admin Portal is a comprehensive administration system for managing urban access passes for students in educational institutions. The platform enables administrators to verify applications, manage users, track divisions, and generate reports for urban transportation access passes.",
        tags: [
            "React",
            "TypeScript",
            "Ant Design",
            "Java",
            "Spring Boot",
            "PostgreSQL",
        ],
        link: "https://github.com/Nagarajukasarla/UrbanAccess-admin",
        year: 2025,
    },
    {
        image: {
            small: "https://raw.githubusercontent.com/Nagarajukasarla/UrbanAccess/master/app/src/main/res/screenshots/main_screens.jpeg",
            medium: "https://raw.githubusercontent.com/Nagarajukasarla/UrbanAccess/master/app/src/main/res/screenshots/main_screens.jpeg",
            large: "https://raw.githubusercontent.com/Nagarajukasarla/UrbanAccess/master/app/src/main/res/screenshots/main_screens.jpeg",
            default:
                "https://raw.githubusercontent.com/Nagarajukasarla/UrbanAccess/master/app/src/main/res/screenshots/main_screens.jpeg",
        },
        title: "Urban Access",
        description:
            "Urban Access is a modern Android application that revolutionizes how users manage and acquire their transportation passes. Built with Material Design 3 principles and a focus on user experience, it provides a seamless interface for purchasing and managing various types of transit passes. ",
        tags: ["Android", "Kotlin", "Jetpack Compose", "Firebase"],
        link: "https://github.com/Nagarajukasarla/UrbanAccess",
        year: 2024,
    },
    {
        image: {
            small: "https://raw.githubusercontent.com/Nagarajukasarla/imagic-restaur/master/src/assets/screenshots/Hero2.png",
            medium: "https://raw.githubusercontent.com/Nagarajukasarla/imagic-restaur/master/src/assets/screenshots/Hero2.png",
            large: "https://raw.githubusercontent.com/Nagarajukasarla/imagic-restaur/master/src/assets/screenshots/Hero2.png",
            default:
                "https://raw.githubusercontent.com/Nagarajukasarla/imagic-restaur/master/src/assets/screenshots/Hero2.png",
        },
        title: "Modern Restaurant",
        description:
            "A modern restaurant design, responsive website for a restaurant that showcases its menu, ambiance, and services. The website is designed to provide an immersive experience for visitors, allowing them to explore the restaurant's offerings, read customer reviews, and make reservations.",
        tags: ["React", "TypeScript", "Tailwind CSS"],
        link: "https://github.com/Nagarajukasarla/imagic-restaur",
        year: 2025,
    },
    {
        image: {
            small: "https://raw.githubusercontent.com/Nagarajukasarla/job-pilot-admin/master/src/assets/Screenshot.png",
            medium: "https://raw.githubusercontent.com/Nagarajukasarla/job-pilot-admin/master/src/assets/Screenshot.png",
            large: "https://raw.githubusercontent.com/Nagarajukasarla/job-pilot-admin/master/src/assets/Screenshot.png",
            default:
                "https://raw.githubusercontent.com/Nagarajukasarla/job-pilot-admin/master/src/assets/Screenshot.png",
        },
        title: "Job Pilot Portal",
        description:
            "A sleek, modern job posting platform built with React, TypeScript, and Supabase. Streamline your recruitment process with our intuitive admin dashboard.",
        tags: ["React", "TypeScript", "Ant Design", "Supabase"],
        link: "https://github.com/Nagarajukasarla/job-pilot-admin",
        year: 2025,
    },
    {
        image: {
            small: "https://raw.githubusercontent.com/Nagarajukasarla/BBA/master/client/src/assets/images/logo.jpg",
            medium: "https://raw.githubusercontent.com/Nagarajukasarla/BBA/master/client/src/assets/images/logo.jpg",
            large: "https://raw.githubusercontent.com/Nagarajukasarla/BBA/master/client/src/assets/images/logo.jpg",
            default:
                "https://raw.githubusercontent.com/Nagarajukasarla/BBA/master/client/src/assets/images/logo.jpg",
        },
        title: "BBA",
        description:
            "BBA is a comprehensive business management solution designed for businesses of all sizes, with special features for pharmaceutical distributors and retailers. It streamlines billing, inventory management, customer relationship management, and business analytics, providing a user-friendly interface for managing day-to-day business operations.",
        tags: [
            "React",
            "TypeScript",
            "Ant Design",
            "Java",
            "Spring Boot",
            "PostgreSQL",
        ],
        link: "https://github.com/Nagarajukasarla/BBA",
        year: 2022,
    },
    {
        image: {
            small: "https://raw.githubusercontent.com/Nagarajukasarla/Portfolio/master/CommonFiles/Img/screen.png",
            medium: "https://raw.githubusercontent.com/Nagarajukasarla/Portfolio/master/CommonFiles/Img/screen.png",
            large: "https://raw.githubusercontent.com/Nagarajukasarla/Portfolio/master/CommonFiles/Img/screen.png",
            default:
                "https://raw.githubusercontent.com/Nagarajukasarla/Portfolio/master/CommonFiles/Img/screen.png",
        },
        title: "Portfolio Website",
        description:
            "A modern, responsive portfolio website built with React, TypeScript, and Vite. It features a sleek, professional design with interactive UI elements, optimized performance, and responsive layouts for all device sizes.",
        tags: ["React", "TypeScript", "Vite"],
        link: "https://github.com/Nagarajukasarla/Portfolio",
        year: 2021,
    },
    {
        image: {
            small: "",
            medium: "",
            large: "",
            default: "",
        },
        title: "User Access Management",
        description:
            "A comprehensive role-based access control system that manages user permissions and tracks their actions within the application.",
        tags: ["Java Servlet", "JavaScript", "CSS"],
        link: "https://github.com/Nagarajukasarla/User-Access-Management",
        year: 2025,
    },
];
